
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 7c6.383 0 11.969 2.063 11.969 2.063l.594.219.063.594 1.344 10.25c.365 2.835-1.665 5.479-4.5 5.844-2.639.34-5.005-1.44-5.625-3.969h-7.688c-.619 2.529-2.985 4.309-5.625 3.969-2.835-.365-4.865-3.009-4.5-5.844l1.344-10.25.063-.594.594-.219S9.619 7 16.002 7zm0 2c-5.486 0-10.007 1.524-10.75 1.781l-1.219 9.625c-.227 1.763.987 3.335 2.75 3.563s3.368-.987 3.594-2.75l.031-.344.125-.875h10.938l.125.875.031.344c.227 1.763 1.832 2.977 3.594 2.75a3.157 3.157 0 002.75-3.563l-1.219-9.625C26.007 10.523 21.486 9 16 9zm-7 3h2v2h2v2h-2v2H9v-2H7v-2h2v-2zm13 0a1 1 0 110 2 1 1 0 010-2zm-2 2a1 1 0 110 2 1 1 0 010-2zm4 0a1 1 0 110 2 1 1 0 010-2zm-2 2a1 1 0 110 2 1 1 0 010-2z"}})])
          )
        }
      }
    